// startup
// Load entry module and return exports
__webpack_require__("./src/scripts/main.js");
__webpack_require__("./src/styles/main/_main.css");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./components/00-icons/ui/plus/plus.svg");
__webpack_require__("./components/00-icons/ui/play/play.svg");
__webpack_require__("./components/00-icons/ui/minus/minus.svg");
__webpack_require__("./components/00-icons/ui/marker/marker.svg");
__webpack_require__("./components/00-icons/ui/marker/marker--track.svg");
__webpack_require__("./components/00-icons/ui/hamburger/hamburger--tn.svg");
__webpack_require__("./components/00-icons/ui/hamburger/hamburger--md.svg");
__webpack_require__("./components/00-icons/ui/download/download.svg");
__webpack_require__("./components/00-icons/ui/arrow/arrow.svg");
__webpack_require__("./components/00-icons/transport/train/train.svg");
__webpack_require__("./components/00-icons/transport/car/car.svg");
__webpack_require__("./components/00-icons/transport/bus/bus.svg");
__webpack_require__("./components/00-icons/social/youtube/youtube.svg");
__webpack_require__("./components/00-icons/social/instagram/instagram.svg");
__webpack_require__("./components/00-icons/social/facebook/facebook.svg");
__webpack_require__("./components/00-icons/social/email/email.svg");
__webpack_require__("./components/00-icons/poi/water/water.svg");
__webpack_require__("./components/00-icons/poi/water/water--marker.svg");
__webpack_require__("./components/00-icons/poi/transport/transport.svg");
__webpack_require__("./components/00-icons/poi/transport/transport--marker.svg");
__webpack_require__("./components/00-icons/poi/sleep/sleep.svg");
__webpack_require__("./components/00-icons/poi/sleep/sleep--marker.svg");
__webpack_require__("./components/00-icons/poi/recharge/recharge.svg");
__webpack_require__("./components/00-icons/poi/recharge/recharge--marker.svg");
__webpack_require__("./components/00-icons/poi/nature/nature.svg");
__webpack_require__("./components/00-icons/poi/nature/nature--marker.svg");
__webpack_require__("./components/00-icons/poi/mechanic/mechanic.svg");
__webpack_require__("./components/00-icons/poi/mechanic/mechanic--marker.svg");
__webpack_require__("./components/00-icons/poi/information/information.svg");
__webpack_require__("./components/00-icons/poi/information/information--marker.svg");
__webpack_require__("./components/00-icons/poi/eat/eat.svg");
__webpack_require__("./components/00-icons/poi/eat/eat--marker.svg");
__webpack_require__("./components/00-icons/poi/culture/culture.svg");
__webpack_require__("./components/00-icons/poi/culture/culture--marker.svg");
__webpack_require__("./components/00-icons/brand/lombardia_logo/lombardia-logo.svg");
__webpack_require__("./components/00-icons/brand/inlombardia_logo/inlombardia-logo.svg");
var __webpack_exports__ = __webpack_require__("./components/00-icons/brand/greenway_logo/greenway-logo.svg");
